<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
    <p>
        {{data.content}}
    </p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="onCancel()">{{data.cancelButtonText || 'Cancel'}}</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="onConfirm()">{{data.confirmButtonText ||
        'Ok'}}</button>
</mat-dialog-actions>
